export default function Partnership() {
  const partnerships = [
    {
      icon: 'ri-chat-smile-2-line',
      title: 'Communication ouverte',
      description: 'Échanges réguliers sur le développement et les progrès de votre enfant'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Rencontres régulières',
      description: 'Rencontres planifiées pour discuter des besoins et objectifs'
    },
    {
      icon: 'ri-group-line',
      title: 'Activités familiales',
      description: 'Événements spéciaux pour renforcer les liens famille-garderie'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Suivis personnalisés',
      description: 'Rapports détaillés sur les activités et apprentissages quotidiens'
    }
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-parent-line text-white text-2xl"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Partenariat avec les parents
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Les parents sont au cœur de notre démarche ! Nous maintenons une communication ouverte et transparente grâce à des suivis réguliers, des rencontres et des activités familiales.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {partnerships.map((item, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-purple-500 to-pink-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-6">
            À la Garderie Les Petits Champions
          </h3>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            Chaque journée est une aventure d'apprentissage et de bonheur — un pas de plus vers un futur plein de réussite !
          </p>
          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-white text-purple-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Rejoignez notre famille
          </button>
        </div>
      </div>
    </section>
  );
}
